import { useGameTime } from "../../../ducks/gameTime";
import styles from "./Player.module.css";
import Time from "./Time";

export default function UserTime({ isRunning }) {
  const { userTime } = useGameTime();

  return (
    <div className={styles.timeContainer}>
      <Time time={userTime} isRunning={isRunning} />
    </div>
  );
}
